const questions = [
    {
      header: "They Used a Virus to Train You to Obey 💉🧪",
      text: "They told you to stay inside. You did.\n\nThey told you to mask up, shut your business, inject yourself and you complied.\n\nNow they know they can take your rights anytime, and you’ll thank them for it.",
      answers: ["emotional language", "binary thinking", "rage bait", "urgency appeal"],
      tacticCount: 4,

      tacticExplanations: {
        "binary thinking": "This post presents only two options: obey or resist. This oversimplifies complex issues and shuts down critical thinking.",
        "rage bait": "This post puts blame on the reader by saying “you complied” to provoke guilt, defensiveness, or outrage.",
        "urgency appeal": "This post suggests it will happen again. Implies that your rights are still under threat (“they can take your rights anytime”), pressuring you to act out of fear.",
        "emotional language": "This post uses dramatic and charged words like “inject yourself” and “take your rights” to stir fear and anger instead of presenting facts calmly.",
        "clickbait": "This post uses sensational or misleading language to draw attention and drive clicks.",
        "selective framing": "This post presents information in a way that supports a particular perspective, leaving out alternative views.",
        "exaggeration": "This post dramatises facts to make a point more persuasive or shocking.",

      },
      image: "/assets/images/game-art/scenarios/mask.png",
      alsoAcceptable: ["exaggeration", "clickbait", "selective framing"],
    },
    {
      header: "They’re Indoctrinating Kids, Not Teaching Them!",
      text: "Math scores are dropping...\n\n but somehow there’s time to teach 8-year-olds about gender identity and activism. What happened to ACTUAL education?!🤡",
      answers: ["rage bait", "selective framing"],
      tacticCount: 2,

      tacticExplanations: {
        "rage bait": "Combines falling test scores and gender topics to spark outrage.",
        "selective framing": "Only picks one example and ignores bigger causes behind education decline.",
        "emotional language": "Uses strong emotional phrasing to provoke feelings instead of encouraging calm analysis.",
        "exaggeration": "This post dramatises facts to make a point more persuasive or shocking.",
        "binary thinking": "Frames issues as black-and-white choices, ignoring complexity or nuance."
      },
      image: "/assets/images/game-art/scenarios/education.png",

      alsoAcceptable: ["emotional language", "exaggeration", "binary thinking"],
    },
    {
      header: "Men Are the Real Victims (But No One Will Say It)",
      text: "Society praises women for EVERYTHING but mocks men for expressing pain. Meanwhile, male suicide rates skyrocket, and feminists just shrug🤣🤡\n\nIf this is what equality looks like, one wonders what oppression actually means...",
      answers: ["binary thinking", "emotional language","exaggeration","selective framing", "rage bait", "pseudo-intellectualism"],
      tacticCount: 6,

      tacticExplanations: {
        "emotional language" : "Uses many emotionally-loaded phrases, such as “mocks men for expressing pain” and “suicide rates skyrocket”",
        "binary thinking": "Frames the situation as women = praised vs men = mocked, with no room for shared struggles or mutual support.",
        "selective framing": "Focuses only on examples that make men look mistreated, while ignoring feminist efforts to support men’s mental health too.",
        "rage bait": "Uses emotionally charged phrases and the 🤡🤣 emojis to provoke anger or resentment.",
        "pseudo-intellectualism": "Ends with “If this is what equality looks like, one wonders what oppression actually means...” a rhetorical question that oversimplifies a serious issue.",
        "exaggeration": "Makes broad claims like 'society praises women for EVERYTHING' and 'feminists just shrug,' which oversimplify complex issues and distort reality.",
        "clickbait": "Uses sensational or misleading language to draw attention and drive clicks.",
        "false equivalence": "Treats two unequal things as if they are logically or morally equivalent.",
        "weaponised irony": "Uses sarcasm, irony, or memes in a mocking way to undermine or ridicule a subject."
      },
      image: "/assets/images/game-art/scenarios/cigar-man.png",
      alsoAcceptable: ["clickbait", "false equivalence", "weaponised irony"],
    },
    {
      header: "You’re Just a Number to Them.",
      text: "They collect your data. Track your every move. Feed you curated content to keep you scrolling and buying...\n\nTo corporations, you’re not a person. You’re a metric. A line on a profit graph.",
      answers: ["not manipulative"],
      tacticCount: 1,

      tacticExplanations: {
        "not manipulative": "This one’s sneaky... it sounds intense, but there are actually no manipulation tactics used here. The language is direct but not exaggerated, the claims are grounded in real-world practices, and there's no push to act, panic, or distrust everything. It’s a critical take, but not a manipulative one."
      },
      image: "/assets/images/game-art/scenarios/anumber.png"
    },
    {
      header: "They Want Your Vote, but only if It’s Digital😂😂",
      text: "Digital ballots are great!.. if you enjoy elections with no paper trail and zero transparency🤣💀\n\n #TheyCallThisDemocracy\n#DigitalBallotsBeLike\n#TrendingNow",
      answers: ["selective framing", "weaponised irony"],
      tacticCount: 2,

      tacticExplanations: {
        "selective framing": "This post only highlights potential downsides of e-voting, while leaving out the advantages and safeguards that exist.",
        "weaponised irony": "The '😂💀' emojis and meme image adds a sarcastic tone, making the argument feel mocking rather than constructive.",
        "clickbait": "The tone and emojis create a headline-style hook that prioritises outrage over nuance.",
        "rage bait": "The '😂💀' emojis and meme image can be seen as provocative, as a result the post is designed to spark anger or outrage."
      },
      image: "/assets/images/game-art/scenarios/drake-meme-evoting.png",
      alsoAcceptable: ["clickbait", "rage bait"],

    },
    {
      header: "She Left Because You Weren’t ‘Growing’ Fast Enough",
      text: "Modern dating isn’t about love. It’s about status. If you’re not on your grind, leveling up, building a brand, she’ll lose interest.\n\nLoyalty isn’t romantic anymore. It’s conditional. 💼💊\n#WakeUp",
      answers: ["selective framing", "emotional language", "binary thinking", "pseudo-intellectualism"],
      tacticCount: 4,

      tacticExplanations: {
        "selective framing": "This post reduces relationships to a transactional, materialistic exchange (e.g., success = love), ignoring emotional, cultural, or social factors.",
        "emotional language": "Words like “left” and “lose interest” tap into fears of rejection and failure, which create an emotional gut reaction instead of inviting calm reflection.",
        "binary thinking": "Frames dating as either you're grinding and winning or struggling and abandoned. No middle ground or nuance allowed.",
        "pseudo-intellectualism": "The claim that “modern dating isn’t about love” may sound insightful, but it's a sweeping generalisation disguised as wisdom.",
        "clickbait": "The phrasing mimics advice content that oversimplifies complex social dynamics to attract attention.",
        "rage bait": "Targets emotional pain points like rejection and loyalty to create resentment.",
        "exaggeration": "Makes broad claims about all women and modern dating as if they apply universally."
      },
      image: "/assets/images/game-art/scenarios/cigar-man.png",
      alsoAcceptable: ["clickbait", "rage bait", "exaggeration"],
    },
    {
      header: "Check In On Your People",
      text: "Just a reminder that it costs nothing to send a ‘how are you doing?’ text.\n\nYou never know who might need it today.\n\n#CheckInOnYourFriends🌻💛",
      answers: ["not manipulative"],
      tacticCount: 1,

      tacticExplanations: {
        "not manipulative": "This one’s real. No hidden tactic... Just a gentle reminder that a small check-in can make a big difference 🙂."
      },
      image: "/assets/images/game-art/scenarios/plant.png"
    },
    {
      header: "When Did the Monopoly Guy Lose His Monocle?!",
      text: "I swear the Monopoly guy used to have a monocle. But apparently, he never did!?😱 It’s so strange how clear that image is in my head. Not tryna be funny... just genuinely curious how that happens.\n\n#IsThisTheMandelaEffect",
      answers: ["not manipulative"],
      tacticCount: 1,

      tacticExplanations: {
        "not manipulative": "No tactics here! Sometimes a post is just someone wondering out loud. No emotional hook, no drama. Just a weird little “wait what” mandela-effect moment shared with the internet."
      },
      image: "/assets/images/game-art/scenarios/monopoly-man.png"
    },
    {
      header: "Too Many Coincidences Lately...",
      text: "You think about someone, and they message you. You take a different route, and bump into an old friend. The same song plays three times in one day.\n\nMaybe it’s just chance… or maybe something’s off.\n\n#WakeUpSheeple",
      answers: ["exaggeration", "emotional language"],
      tacticCount: 2,

      tacticExplanations: {
        "exaggeration": "This post stacks multiple vague 'coincidences' in a way that makes them feel statistically significant, even though no evidence is presented.",
        "emotional language": "Phrases like 'maybe something’s off' tap into subtle unease and paranoia without saying anything directly... it’s all about the vibe.",
        "clickbait": "The setup mimics a viral mystery post that’s meant to get people intrigued or creeped out.",
        "selective framing": "Only includes ‘eerie’ coincidences without any statistical or mundane explanations.",
        "rage bait": "While milder, the hashtag '#WakeUpSheeple'pushes subtle frustration at the idea people aren’t noticing the pattern."
      },
      alsoAcceptable: ["clickbait","selective framing", "rage bait"],
    },
    {
      header: "You Were Born Poor. And Programmed to Stay That Way.",
      text: "They taught you to follow rules. To obey. To sit in class, get a job, pay taxes, die. Meanwhile, the ones who broke the rules own the game.\n\nYou’re not free. You’re in the Matrix. And the Matrix rewards the weak for staying asleep. 🟥💊⏳💸",
      answers: ["binary thinking", "rage bait"],
      tacticCount: 2,

      tacticExplanations: {
        "binary thinking": "According to this poster... You’re either escaping the Matrix or stuck in it. No middle path, no nuance.",
        "rage bait": "Calls you weak and asleep just to push you into fight mode.",
        "emotional language": "Phrases like 'pay taxes, die' and 'own the game' are designed to provoke anger at injustice.",
        "clickbait": "The dramatic framing and Matrix references are engineered for clicks and reaction.",
        "selective framing": "Only shows systems of control — ignores real complexity in economic or social mobility."
      },
      image: "/assets/images/game-art/scenarios/matrix.png",
      alsoAcceptable: ["emotional language","clickbait", "selective framing"],

    },
    {
      header: "🌿Why Do You Think They Push Houseplants So Hard?",
      text: "Every influencer has plants now. Every store sells them. They’re not just decor, they’re conditioning you!\n\nStay home. Stay still. Stay small.\n\nDon't you see?! You’re not meant to grow roots. You’re meant to be contained.",
      answers: ["exaggeration", "pseudo-intellectualism"],
      tacticCount: 2,

      tacticExplanations: {
        "exaggeration": "Takes something harmless — like liking plants — and turns it into a full-blown conspiracy.",
        "pseudo-intellectualism": "Sounds deep with poetic metaphors, but there’s no real evidence. Just vibes.",
        "emotional language": "Uses metaphors like 'stay small' and 'stay still' to create subtle fear or resistance.",
        "clickbait": "Framed like a hidden truth or theory designed to grab attention.",
        "selective framing": "Ignores harmless reasons people like plants and instead spins a narrative of control."
      },
      image: "/assets/images/game-art/scenarios/plant.png",
      alsoAcceptable: ["emotional language", "clickbait","selective framing"],

    },
    {
      header: "The Matrix as a Metaphor 👩🏽‍💻",
      text: "Some people relate to The Matrix as a way of expressing how modern life can feel repetitive or disconnected.\n\nThe film’s concept has become a popular metaphor for questioning habits and exploring different perspectives... It's worth watching if you haven't already!\n#TheMatrix #MediaAnalyysis",
      answers: ["not manipulative"],
      tacticCount: 1,

      tacticExplanations: {
        "not manipulative": "This poster is just genuinely thoughtful. They're connecting a movie to how they feel. No tricks here."
      },
      image: "/assets/images/game-art/scenarios/matrix.png"
    },
    {
      header: "You Don’t Have to Earn Rest",
      text: "You’re allowed to take a break just because you’re tired.\n\nNot because you finished everything.\n\nNot because you were productive.\n\nJust because you’re human. 🕯️",
      answers: ["not manipulative"],
      tacticCount: 1,
      
      tacticExplanations: {
        "not manipulative": "A soft reminder that you don’t need to burn out to deserve rest. No pressure. No shame. Just… yeah. You're allowed to stop."
      },
      image: "/assets/images/game-art/scenarios/cat.png"
    },
    {
      header: "If It Was a Fair Election... Why Hide the Numbers?",
      text: "Funny how the mainstream media won’t show the full breakdown.\n\nThousands of ballots ‘misplaced.’ Voter turnout higher than the registered population in some districts.\n\nBut sure - keep pretending everything adds up...",
      answers: ["rage bait", "selective framing"],
      tacticCount: 2,

      tacticExplanations: {
        "rage bait": "Wants you angry at institutions — especially if you already feel distrust. That’s the whole play.",
        "selective framing": "Picks out suspicious claims but leaves out context, like audits or transparency tools.",
        "emotional language": "Terms like 'keep pretending everything adds up' provoke frustration or paranoia.",
        "clickbait": "Structured to draw outrage and shares without encouraging full understanding.",
        "exaggeration": "Implies widespread fraud based on a few isolated claims with no clear evidence."
      },
      image: "/assets/images/game-art/scenarios/evoting.png",
      alsoAcceptable: ["emotional language", "clickbait","exaggeration"],

    },
    {
      header: "Turns Out, That Headline Wasn’t the Whole Story",
      text: "You might’ve seen the story about a ‘common snack ingredient linked to brain damage.’ The headline went viral but the study it was based on used doses thousands of times higher than you'd ever consume. The researchers themselves warned against misinterpretation.\n\nAlways worth reading past the headline👀.",
      answers: ["not manipulative"],
      tacticCount: 1,

      tacticExplanations: {
         "not manipulative": "This post's actually helpful! It calls out how headlines can mislead without going full fear-bait. Just good advice."
      },
      image: "/assets/images/game-art/scenarios/cereal.png"
    },
    {
      header: "So It’s Cool When *They* Say It in a Song?",
      text: "#MakeItMakeSense\nRappers can use slurs, brag about crime, and say whatever they want and it’s ‘art.’\n\nBut if anyone else repeats those lyrics, it’s suddenly offensive?🎤🤔",
      answers: ["false equivalence", "selective framing"],
      tacticCount: 2,

      tacticExplanations: {
        "false equivalence": "Treats lyrical self-expression and casual use by outsiders as if they have the same cultural weight — ignoring context, history, and who the words are aimed at.",
        "selective framing": "Focuses only on the ‘double standard’ without acknowledging why certain words carry different meanings depending on who says them.",
        "emotional language": "Uses sarcasm and phrases like 'make it make sense' to provoke indignation.",
        "clickbait": "Uses controversy and casual tone to bait reactions instead of nuanced conversation.",
        "rage bait": "Designed to stir outrage about perceived injustice in popular culture."
      },
      image: "/assets/images/game-art/scenarios/rap-double-standard.png",
      alsoAcceptable: ["emotional language", "clickbait","rage bait"],

    },
    {
      header: "If You Don’t Care, Then Say So.",
      text: "They’re out there protesting again, but sure—stay comfy. Keep scrolling. Ignore it. Must be nice to live in a world where nothing affects you. 🙂",
      answers: ["emotional language"],
      tacticCount: 1,
      
      tacticExplanations: {
        "emotional language": "Uses guilt, sarcasm, and passive-aggressive phrasing to stir feelings of shame or defensiveness instead of inviting real discussion.",
        "clickbait": "Delivers a strong emotional punch with minimal context, this makes it structured more for attention and reactions.",
        "selective framing": "Implies moral failure by ignoring any valid reasons for non-participation.",
        "rage bait": "Designed to call people out and stir emotional defensiveness or backlash."
      },
      image: "/assets/images/game-art/scenarios/evoting.png",
      alsoAcceptable: ["emotional language", "clickbait","rage bait"],

    }
  ];
  
  export default questions;

  /* scenario template
    {
    header: "title",
    text: "post",
    answers: ["tactic", "tactic"],
    image: "/assets/images/scenarios/blahblahblah.png"
  }*/